import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, ShoppingBagIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { navLeft, navRight } from '../../data/site';
import { useCart } from '../../contexts/CartContext';
const linkClass = ({
  isActive
}: {
  isActive: boolean;
}) => `whitespace-nowrap font-slab text-[13px] font-bold uppercase tracking-[0.2em] transition-opacity duration-150 ease-out ${isActive ? 'opacity-100 underline decoration-1 underline-offset-[10px]' : 'opacity-90 hover:opacity-60'}`;
export function Header() {
  const {
    count
  } = useCart();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname]);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  const cartLink = <Link to="/cart" className="relative inline-flex p-1 transition-opacity duration-150 ease-out hover:opacity-60" aria-label={`Cart, ${count} items`} data-id="element-123" data-mp="6uvoxiabrhxa">
      <ShoppingBagIcon className="h-6 w-6" strokeWidth={1.5} data-id="element-124" data-mp="glhwcp7w124w" />
      <span className="absolute -right-2 -top-1 font-slab text-[11px] font-bold" data-id="element-125" data-mp="gm9vga0p1hzx">{count}</span>
    </Link>;
  return <header className="absolute inset-x-0 top-0 z-40" data-id="element-126" data-mp="lme2l9fpp0dh">
      <div className="mx-auto hidden max-w-[1400px] items-center justify-center gap-10 px-8 py-4 xl:flex 2xl:gap-14" data-id="element-127" data-mp="3k3iayn7y85rh">
        <nav aria-label="Primary left" className="flex items-center gap-10 2xl:gap-14" data-id="element-128" data-mp="3p1jt95xjw11w">
          {navLeft.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={linkClass} data-id="element-129" data-mp="3u2r092rvcw7i">
              {item.label}
            </NavLink>)}
        </nav>
        <Link to="/" aria-label="Trip Ink Tattoo home" className="shrink-0" data-id="element-130" data-mp="199m55jlr9vbt">
          <Logo className="h-[100px] w-[100px]" data-id="element-131" data-mp="1dapnccra03g7" />
        </Link>
        <nav aria-label="Primary right" className="flex items-center gap-10 2xl:gap-14" data-id="element-132" data-mp="3acdcjgg2w5yc">
          {navRight.map(item => <NavLink key={item.to} to={item.to} className={linkClass} data-id="element-133" data-mp="35e3gz4qfz3c7">
              {item.label}
            </NavLink>)}
          {cartLink}
        </nav>
      </div>

      <div className="flex items-center justify-between px-5 py-4 xl:hidden" data-id="element-134" data-mp="3ee8bieaje78y">
        <Link to="/" aria-label="Trip Ink Tattoo home" data-id="element-135" data-mp="3ec5nu0wuwq7e">
          <Logo className="h-16 w-16" data-id="element-136" data-mp="2qp7ahc419ydp" />
        </Link>
        <div className="flex items-center gap-5" data-id="element-137" data-mp="2mn2h8ehhz3rl">
          {cartLink}
          <button type="button" onClick={() => setOpen(true)} aria-label="Open menu" aria-expanded={open} className="p-1" data-id="element-138" data-mp="2mkpqpcxobl2x">
            <MenuIcon className="h-7 w-7" strokeWidth={1.5} data-id="element-139" data-mp="2vnh1daiq6cti" />
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-140" data-mp="27xmud9l37ih6">
        {open && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed inset-0 z-50 flex flex-col bg-ink px-6 py-5 xl:hidden" role="dialog" aria-modal="true" aria-label="Menu" data-id="element-141" data-mp="27wbp15bzu2ny">
            <div className="flex items-center justify-between" data-id="element-142" data-mp="9h5ief9i2imo">
              <Logo className="h-16 w-16" data-id="element-143" data-mp="eexn69v8tz8a" />
              <button type="button" onClick={() => setOpen(false)} aria-label="Close menu" className="p-1" data-id="element-144" data-mp="efz0ym3n8ztp">
                <XIcon className="h-7 w-7" strokeWidth={1.5} data-id="element-145" data-mp="1259qf7fjn7sj" />
              </button>
            </div>
            <nav aria-label="Mobile" className="mt-10 flex flex-col gap-1" data-id="element-146" data-mp="165tr2kzbstjf">
              {[...navLeft, ...navRight].map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
            isActive
          }) => `border-b border-ink-line py-4 font-slab text-lg font-bold uppercase tracking-[0.2em] ${isActive ? 'text-white' : 'text-ink-muted'}`} data-id="element-147" data-mp="x5oqaton0te8">
                  {item.label}
                </NavLink>)}
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}